/**
 * Live feedback, computed from the islands and the drawn bridges alone (CLAUDE.md §10): the
 * bridges of the answer key never reach this code.
 */
import type { Feedback } from "../types";
import { canonical, contradictions, legalBridges } from "./graph";
import { gridOf } from "./progress";
import { cellId, type BridgesDefinition, type BridgesProgress } from "./types";

export const ISLAND_OVER = "island_over";
export const ISLAND_SHORT = "island_short";
export const BRIDGES_CROSSING = "bridges_crossing";
export const ISOLATED_GROUP = "isolated_group";

export function liveContradictions(definition: BridgesDefinition, progress: BridgesProgress) {
  const grid = gridOf(definition);
  const bridges = canonical(legalBridges(grid, progress.bridges));
  return { bridges, found: contradictions(grid, bridges) };
}

export function localFeedback(
  definition: BridgesDefinition,
  progress: BridgesProgress,
): Feedback[] {
  const { bridges, found } = liveContradictions(definition, progress);
  const feedback: Feedback[] = [
    ...found.over.map(([r, c]) => ({ type: "island", code: ISLAND_OVER, cells: [cellId(r, c)] })),
    ...found.short.map(([r, c]) => ({
      type: "island",
      code: ISLAND_SHORT,
      cells: [cellId(r, c)],
    })),
  ];
  if (found.crossing.length > 0)
    feedback.push({
      type: "bridge",
      code: BRIDGES_CROSSING,
      cells: found.crossing.flatMap((index) => {
        const { a, b } = bridges[index];
        return [cellId(a[0], a[1]), cellId(b[0], b[1])];
      }),
    });
  if (found.isolated.length > 0)
    feedback.push({
      type: "group",
      code: ISOLATED_GROUP,
      cells: found.isolated.map(([r, c]) => cellId(r, c)),
    });
  return feedback;
}
